import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Code, Wrench, Database, Package } from 'lucide-react';
import { skills } from '../data/mock';

const Skills = () => {
  const skillCategories = [
    {
      title: "Programming Languages",
      icon: <Code className="w-5 h-5" />,
      items: skills.languages,
      color: "blue"
    },
    {
      title: "Frameworks & Libraries",
      icon: <Package className="w-5 h-5" />,
      items: skills.frameworks,
      color: "cyan"
    },
    {
      title: "Tools & Platforms",
      icon: <Wrench className="w-5 h-5" />,
      items: skills.tools,
      color: "blue"
    },
    {
      title: "Databases",
      icon: <Database className="w-5 h-5" />,
      items: skills.databases,
      color: "cyan"
    }
  ];

  return (
    <section id="skills" className="py-24 bg-slate-950">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Technical <span className="text-blue-400">Skills</span>
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto mb-4"></div>
            <p className="text-gray-400 max-w-2xl mx-auto">
              A comprehensive toolkit of technologies and tools I work with to build robust applications
            </p>
          </div>

          {/* Skills Grid */}
          <div className="grid md:grid-cols-2 gap-6">
            {skillCategories.map((category, index) => (
              <Card 
                key={index} 
                className="bg-slate-900/50 border-slate-800 p-8 backdrop-blur-sm hover:border-blue-500/30 transition-all duration-300 group"
              >
                <div className="flex items-center mb-6">
                  <div className={`w-12 h-12 rounded-lg bg-${category.color}-500/10 flex items-center justify-center mr-4 group-hover:bg-${category.color}-500/20 transition-colors`}>
                    <span className="text-blue-400">{category.icon}</span>
                  </div>
                  <h3 className="text-xl font-bold text-white">{category.title}</h3>
                </div>
                
                <div className="flex flex-wrap gap-2">
                  {category.items.map((skill, idx) => (
                    <Badge 
                      key={idx} 
                      variant="secondary" 
                      className="bg-slate-800 text-gray-300 hover:bg-blue-500/20 hover:text-blue-400 border border-slate-700 hover:border-blue-500/30 px-4 py-2 text-sm transition-all duration-300 cursor-default"
                    >
                      {skill}
                    </Badge>
                  ))}
                </div>
              </Card>
            ))}
          </div>

          {/* Additional Info */}
          <div className="mt-12 text-center">
            <Card className="bg-gradient-to-r from-blue-500/10 to-cyan-500/10 border-blue-500/20 p-8 backdrop-blur-sm">
              <p className="text-gray-300 text-lg">
                <span className="font-semibold text-white">Always Learning:</span> Passionate about exploring new technologies and expanding my skill set in <span className="text-blue-400">AI, Cloud Computing</span>, and modern development practices.
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
